import {MD_WIDTH, LG_WIDTH} from "@main/helpers/const";

const TIMEOUT_RESIZE_OBSERVER = 100;
/**
 * Класс "Показать все элементы".
 */
class ShowAllElements {
    isOpen = false;
    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;
        this.listElements = this.el.querySelector(".js-mch-show-elements-list");
        this.elements = [...this.listElements.children];
        this.numElementsOnMobile = this.listElements.dataset.elementsMobile;
        this.numElementsOnTablet = this.listElements.dataset.elementsTablet;
        this.numElementsOnDesktop = this.listElements.dataset.elementsDesktop;
        this.btn = this.el.querySelector(".js-mch-show-elements-btn");
        this.resizeObserver = new ResizeObserver(
            this.onResizeWindow.bind(this),
            TIMEOUT_RESIZE_OBSERVER
        );
        this.resizeObserver.observe(document.body);

        this.bindEventListeners();
    }

    /**
     * Отслеживание события клика на кнопку.
     *
     * @returns {void}
     */
    bindEventListeners() {
        this.btn.addEventListener("click", this.openElementsOnClick);
    }

    /**
     * Показываем все элементы в списке.
     * Скрываем кнопку.
     *
     * @returns {void}
     */
    openElementsOnClick = () => {
        this.isOpen = true;
        this.elements.forEach((el) => (el.style.display = "flex"));
        this.btn.classList.add("hidden");
    };

    /**
     * Действия, происходящие на ресайз окна.
     *
     * @param entry Pазмеры наблюдаемого элемента.
     * @returns {void}
     */
    onResizeWindow([entry]) {
        this.getWindowWidth(entry.contentRect.width);
        this.showAllElements();
        this.toggleVisibilityBtnAndElements();
    }

    /**
     * Получаем ширину окна.
     *
     * @param width Ширина наблюдаемого элемента.
     * @returns {void}
     */
    getWindowWidth(width) {
        this.isMobile = width < MD_WIDTH;
        this.isTablet = width >= MD_WIDTH && width < LG_WIDTH;
        this.isDesktop = width >= LG_WIDTH;
    }

    /**
     * Показываем все элементы в списке и скрываем кнопку, если количество
     * отображаемых элементов равно all.
     *
     * @returns {void}
     */
    showAllElements() {
        if (
            (this.isMobile && this.numElementsOnMobile === "all") ||
            (this.isTablet && this.numElementsOnTablet === "all") ||
            (this.isDesktop && this.numElementsOnDesktop === "all")
        ) {
            this.listElements.classList.add("expand");
            this.btn.classList.add("hidden");
        }
    }

    /**
     * Переключаем видимость элементов в списке и кнопки.
     * Отслеживаем ширину окна, количество отображаемых элементов и isOpen.
     *
     * @returns {void}
     */
    toggleVisibilityBtnAndElements() {
        for (let i = 0; i < this.elements.length; i++) {
            if (
                (this.isMobile &&
                    i >= this.numElementsOnMobile &&
                    !this.isOpen) ||
                (this.isTablet &&
                    i >= this.numElementsOnTablet &&
                    !this.isOpen) ||
                (this.isDesktop &&
                    i >= this.numElementsOnDesktop &&
                    !this.isOpen)
            ) {
                this.elements[i].style.display = "none";
                this.btn.classList.remove("hidden");
            } else {
                this.elements[i].style.display = "flex";
                this.btn.classList.add("hidden");
            }
        }
    }
}

document
    .querySelectorAll(".js-mch-show-elements")
    .forEach((node) => new ShowAllElements(node));
